import { getPfmInstance } from '@shared/api';
import type { DateLib } from '@shared/lib';

export const DatesPickerApi = {
  getCalendarDates(countryToId: number, townFromId: number) {
    const pfm = getPfmInstance();
    return pfm.tourflow.getCalendarDates(townFromId, countryToId);
  },
  getNightsCount(
    countryToId: number,
    townFromId: number,
    dateFrom: DateLib.DateProp,
    dateTo: DateLib.DateProp,
  ) {
    const pfm = getPfmInstance();

    return pfm.tourflow.getAvailableNights({
      townFromId,
      countryToId,
      dateFrom: dateFrom as string,
      dateTo: dateTo as string,
    });
  },
};
